import React, { useCallback, useContext, useState } from 'react';
import { Box, IconButton, makeStyles } from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { MeetingFuncsContext } from '../CreateEditMeetingsProvider';
import InputField from '../../common/forms/InputField';
import Subtitle2 from '../../common/typographys/Subtitle2';

const useStyles = makeStyles(() => ({
  participantBox: {
    display: 'flex',
    alignItems: 'start'
  },
  participantInput: {

  },
  deleteButton: {
    'margin-top': '20px',
    'margin-left': '8px',
  }
}));

const PublicParticipants = ({ participants }) => {
  const classes = useStyles();

  const { updateField } = useContext(MeetingFuncsContext);
  const [newParticipant, setNewParticipant] = useState('');

  const handleAddParticipant = useCallback(() => {
    const trimmedName = newParticipant.trim();
    if (!trimmedName) return;

    const newParticipantObj = {
      id: Date.now(),
      name: trimmedName,
    };

    updateField('publicParticipants', [...participants, newParticipantObj]);
    setNewParticipant('');
  }, [newParticipant, participants, updateField]);

  const handleRemoveParticipant = useCallback(
    participantId => {
      updateField('publicParticipants', participants.filter(p => p.id !== participantId));
    },
    [participants, updateField]
  );

  const handleKeyPress = useCallback(
    e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleAddParticipant();
      }
    },
    [handleAddParticipant]
  );

  return (
    <Box>
      <Subtitle2>Participantes</Subtitle2>

      {participants.map(participant => (
        <Box className={classes.participantBox} key={participant.id}>
          <Box flex={1}>
            <InputField
              className={classes.participantInput}
              value={participant.name}
              disabled
              onChange={() => null}
            />
          </Box>
          <IconButton
            className={classes.deleteButton}
            size="small"
            onClick={() => handleRemoveParticipant(participant.id)}
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}
      <InputField
        value={newParticipant}
        onChange={e => setNewParticipant(e.target.value)}
        onKeyPress={handleKeyPress}
        onBlur={handleAddParticipant}
        placeholder="Nome do participante"
      />
    </Box>
  );
};

PublicParticipants.defaultProps = {
  participants: [],
};

PublicParticipants.propTypes = {
  participants: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
};

export default React.memo(PublicParticipants);
